import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { DropdownAutocomplete } from 'legacy/lut/components/widgets/public/partner360/editors/DropdownAutocomplete'
import { FC, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { useGetFormDataField } from 'cng-common/features/form'
import { Translation } from 'cng-common/features/translations'
import { TranslationMode } from 'cng-common/features/translations/configs'
import { useSafetyTranslation } from 'cng-common/features/translations/hooks'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'
import { selectAppId } from 'core-components/sitebuilder/store/selectors/selectAppId'

import { HP_CONTACT_REQUEST_EDITOR_FORM } from '../../config'
import { getAppUsersAppsSearchCrud, getCleanEmail } from '../../lib'

interface IManagersSearchProps {
  email: string // manager's email
  label: string
  checkFn?: (email: string) => Promise<string>
}

const MANAGER_SEARCH_PLACEHOLDER = 'jbp-hpcontactinfo-manager-search-placeholder'

export const ManagersSearch: FC<IManagersSearchProps> = ({ label }) => {
  const t = useSafetyTranslation()
  const translationMode = useSelector(selectTranslationMode)
  const isTranslationMode = translationMode === TranslationMode.Edit

  const [managerEmailFormValue, onChangeManagerEmail] = useGetFormDataField<string>(
    HP_CONTACT_REQUEST_EDITOR_FORM,
    'ManagerEmail'
  )

  const [, onChangeManagerFirstName] = useGetFormDataField(
    HP_CONTACT_REQUEST_EDITOR_FORM,
    'ManagerFirstName'
  )
  const [, onChangeManagerLastName] = useGetFormDataField(
    HP_CONTACT_REQUEST_EDITOR_FORM,
    'ManagerLastName'
  )

  const changeEmail = useCallback(
    (newValue: string) => {
      const cleanEmail = getCleanEmail(newValue)
      onChangeManagerEmail(cleanEmail)
    },
    [onChangeManagerEmail]
  )

  const changeEmailItem = useCallback(
    (emailItem: IObjectAny) => {
      changeEmail(emailItem['Id'])
      onChangeManagerFirstName(emailItem['FirstName'])
      onChangeManagerLastName(emailItem['LastName'])
    },
    [changeEmail, onChangeManagerFirstName, onChangeManagerLastName]
  )

  const appId = useSelector(selectAppId)

  const managerCrud = useMemo(() => {
    return getAppUsersAppsSearchCrud({ appId })
  }, [appId])

  return (
    <>
      <DropdownAutocomplete
        label={label}
        fieldsToSearch={['UserAccountName']}
        calculateCaption={(item: IObjectAny) => `${item.FirstName} ${item.LastName} <${item.Id}>`}
        value={managerEmailFormValue || ''}
        source={managerCrud}
        validateName="Id"
        mode="combobox"
        minimumSearchLength={3}
        placeholder={t(MANAGER_SEARCH_PLACEHOLDER)}
        checkFn={(value) => ValidationHelper.checkFullEmail(value, ['@hp.com'])}
        onChange={changeEmail}
        onItemChange={changeEmailItem}
        translation="jbp-hpcontactinfo-manager-email-required"
      />
      <RenderWhen condition={isTranslationMode}>
        <Translation text={MANAGER_SEARCH_PLACEHOLDER} span />
      </RenderWhen>
    </>
  )
}
